// extracted by mini-css-extract-plugin
export default {"baseButton":"BaseButton_baseButton__a3dn7"};